import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LightbulbRounded from "@mui/icons-material/LightbulbRounded";
import {useIsMobile} from "hooks/useIsMobile";
const TipsCard = ({ tipsText, currentTab }) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <Grid item xs={12} sx={{mt: 2}}>
        <Card elevation={3} sx={{backgroundColor: "#f9f9f9"}}>
          <Accordion
            defaultExpanded={false} // Set to true if you want it open by default
            sx={{
              backgroundColor: "#f9f9f9",
              boxShadow: "none", // Remove default accordion shadow
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              sx={{
                padding: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                  pl: 2
                },
              }}
            >
              <LightbulbRounded
                fontSize="small"
                sx={{ color: "#fdd835", marginRight: 1, marginTop: 0.5 }}
              />
              <Typography variant="body1" sx={{fontWeight: 600}}>
                Tips
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {/* Render Each Tip with Icon and Spacing */}
              <Grid container direction="column" spacing={1}>
                {tipsText[currentTab].map((text, i) => (
                  <Grid item key={`tip_${i}`}>
                    <Box display="flex" alignItems="flex-start">
                      <LightbulbRounded
                        fontSize="small"
                        sx={{color: "#fdd835", marginRight: 1, marginTop: 0.5}}
                      />
                      <Typography variant="body2" gutterBottom>
                        {text}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Card>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Card elevation={3} sx={{ backgroundColor: "#f9f9f9" }}>
        <CardContent>
          {/* Tips Header */}
          <Grid container alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <Grid item>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Tips
              </Typography>
            </Grid>
          </Grid>

          {/* Render Each Tip with Icon and Spacing */}
          <Grid container direction="column" spacing={1}>
            {tipsText[currentTab].map((text, i) => (
              <Grid item key={`tip_${i}`}>
                <Box display="flex" alignItems="flex-start">
                  <LightbulbRounded
                    fontSize="small"
                    sx={{ color: "#fdd835", marginRight: 1, marginTop: 0.5 }}
                  />
                  <Typography variant="body2" gutterBottom>
                    {text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
};

export default TipsCard;
